import React from "react";
import { toast } from "react-toastify";

import axios from "../../../../../../axios-instance";
import { getHeaders } from "../../../../../../helpers/getHeaders";
import { getSeatDescription } from "../../../../../../helpers/getSeatDescription";

export const ConfirmRefundTicketsModal = ({
  token,
  seats,
  setActionLoading,
  getEventTransactions,
  refundWithFee,
  transaction,
  closeModalHandler,
}) => {
  const { processingFeeRate, processingFixedFeeRate, currency } = transaction;

  const refundTicketsHandler = () => {
    const idsSeats = seats.map((seat) => seat.id);
    setActionLoading(true);

    axios
      .post(`/ManageTransactions/Refund?withFee=${refundWithFee}`, idsSeats, {
        headers: getHeaders(token),
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            toast.success("Tickets successfully refunded");
            getEventTransactions(token);
            closeModalHandler();
          } else {
            toast.error("Tickets not refunded");
          }
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error("Tickets not refunded");
      })
      .finally(() => {
        setActionLoading(false)
      });
  };

  return (
    <>
      <div className="seats-list">
        <span>Tickets that will be refunded:</span>
        {seats.map((seat) => (
          <span key={seat.id}>{getSeatDescription(seat, currency, processingFeeRate, processingFixedFeeRate, refundWithFee)}</span>
        ))}
      </div>
      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled"
          onClick={refundTicketsHandler}
        >
          Refund
        </button>
      </div>
    </>
  );
};
